webpackJsonp([35783957827783],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(296);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: _indexModule2.default.homePage },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hi, I\u2019m ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Shane Korin'
	      ),
	      ' and I make interactive digital software and stuff for the web.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I run digital development studio',
	      ' ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'http://distriqt.com' },
	          'distriqt'
	        )
	      ),
	      ' ',
	      'with my friend and business partner Michael. We provide software development, plus contracting and consulting services for companies, agencies and direct clients.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.bottom },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _indexModule2.default.link, to: '/resume' },
	        'My resume'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _indexModule2.default.link, to: '/contact' },
	        'Get in touch'
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          className: _indexModule2.default.link,
	          target: '_blank',
	          href: 'https://www.linkedin.com/in/koriner/'
	        },
	        'LinkedIn'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homePage":"src-pages----index-module---homePage---ASJ9f","bottom":"src-pages----index-module---bottom---bemED","link":"src-pages----index-module---link---3a3Th"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-975eb057d4971a756653.js